import React from 'react'
import { useNavigate } from 'react-router-dom'
import { dispatch } from '../redux'
import { logout } from '../redux/action/userActions'
import { getDecryptRole } from '../util/crypto'
import { allAccess } from '../util/userBasedAuth'
import NoUser from '../assets/images/noUser.svg'
import { FormattedMessage } from 'react-intl'

const UserNotFound = () => {
  const navigate = useNavigate()
  const userType = getDecryptRole() || ''
  const handleLogout = () => {
    dispatch(logout())
    navigate('/auth/login')
  }

  return (
    <div>
      {!allAccess?.includes(userType) && (
        <div className="d-flex flex-column justify-content-center align-items-center text-center h-100vh">
          <h4 className="font-size-24 fw-semibold mb-4 pb-2">
            <FormattedMessage
              id="Sorry_User_Not_Found"
              defaultMessage="Sorry, user not found"
            />
          </h4>
          <img src={NoUser} alt="No User" className="mb-4" />
          <p className="font-size-18 custom-text-muted text-center mb-5">
            <FormattedMessage
              id="Looks_Like_The_User_You_Are_Trying_To_Find_Is_Not_Available"
              defaultMessage="Looks like the user you are trying to find is not available."
            />
          </p>
          <button onClick={handleLogout} className="btn btn-primary px-4">
            <FormattedMessage id="Login" defaultMessage="Login" />
          </button>
        </div>
      )}
    </div>
  )
}

export default UserNotFound
